import { useEffect, useMemo, useRef, useState } from "react"
// import { useHistory } from 'react-router-dom'


import SelectFabric from "./Select/selectFabric"
import ViewFabric from "./View/viewFabric"
import "./fabric.css"
import youtube from '../assets/Arrow/yt.png'

import m_logo from '../assets/measur.svg'
import close from '../assets/icon/close_s.png'

import dArrow from '../assets/icon/darrow_w.png'
import uArrow from '../assets/icon/uparrow_w.png'

import barrowL from '../assets/Arrow/barrowL1.png'
import barrowR from '../assets/Arrow/barrowR.png'

import bclose from '../assets/Arrow/bclose.png'

import lArrow from '../assets/ALeft.png'
import rArrow from '../assets/ARight.png'

import logo_name from '../assets/logo_name.svg'

import raymond from '../assets/icon/Raymond.svg'

import aim from '../assets/samples/anima.gif'

import FabricIcon from '../assets/SVG/FABRIC_STYLE_EMB/FABRIC.svg'
import StyleIcon from '../assets/SVG/FABRIC_STYLE_EMB/STYLE-01.svg'
import EmbIcon from '../assets/SVG/FABRIC_STYLE_EMB/EMBROIDERY.svg'
import MeasureIcon from '../assets/SVG/FABRIC_STYLE_EMB/MEASOURMENT-01.svg'

// import {Fabrics_all} from '../Data/index'
import { fabricFilter, StylesFilter} from '../Data/index'
import StyleP from "./Style"
import Measurement from "../Measurements"
import NavBar from "../Navbar"
import { useMatch, useNavigate, useParams } from "react-router-dom"
import { getButtons, getData, getDatafromDoc, getDocOnCondition, getDocsFromQueryForFabrics, getEmbroidery, getEmbroideryStyle, getFabricDetails, getTuxedo } from "../Firebase/firestoreGet"

import { Types } from "../Data/index"
import FilterFabric from "./Select/Filter"
import { db } from "../firebase"
import { applyFilters, checkCategory, decodeObj, encodeObj, extractUniqueFabricAttributes, getCoatLayers, getVestLayers, isEmbEnabled, setEmbroideryImages } from "../Functions"

import { Body_config } from "../Data/index"
import { Edit2 } from 'lucide-react';
// import wrist from '../assets/Body/wrist.png'
// import hands from '../assets/Body/hand.png'

import wrist from '../assets/Body/formal_hand_2.webp'
import hands from '../assets/Body/formal_hand_1.webp'

// import kurta_hand_k from '../assets/Body/kurta_hand_k.png'

import pajama_body from '../assets/Body/pajama_body.png'
import ClothSelect from "./clothSelect"
import MetaTags from "../meta"
import {tags} from '../Data/metaTags'
import Button_selection from "./Resources/buttonSelection"
import Embroidery from "./Embroidery"
import SelectItemDialog from "./StyleSelector/styleSelectionDialog"
import Emb_modal from "./Feel/emb_modal"

export default function Fabric(){


    const {id} = useParams()   /// select_cloth,  select_fabric, select_style
    const {category} = useParams()   // suit, kurta , ....
    const {process} = useParams()    // personalize
    const {info} = useParams() // sel info

    const Navs = ["select_cloth",  "select_fabric", "select_style", "select_embroidery"]
    const getPage = (id)=>{
        const index = Navs.indexOf(id);
        return index === -1 ? 0 : index;
    }
    const [nav, setNav] = useState( getPage(id) );
    useEffect(()=>{
        setNav(getPage(id))
        // console.log("ID changing", id)
    }, [id])




    //const [sel_session, setSelSession] = useState(JSON.parse(sessionStorage.getItem("sel")))

    const navigate = useNavigate()
    // const history = useHistory()

    const [Fabrics_all, setFabricsAll] = useState({})
    const [useFabric, setUseFabric] = useState({})

    // useEffect(()=>{
        
    //     navigate( `/custom/${category}/${id}/${process}` )
    //         // setNav( ["suit", "kurta"].includes(category) ? -1 : 0 )
        
    // }, [id])

    const [loading, setLoading] = useState(true)

    const [clickHover, setClickHover] = useState(0)

    const [state, setStates] = useState(1)
    const [single, setSingle] = useState([])

    const [section, setSection] = useState(0)
    
    const [fabSame, setFabSame] = useState(
        category === "suit" ? true : false
    )

    const [indication, setIndication] = useState(false)

    const [jodh, setJodh] = useState(0)

    const [LoadFabInfo, setFabricInfoLoad] = useState(true)

    const [STYLESALL, setStylesAll] = useState({
        "Coat":{
            display : {},
            style :{}   
        },
        "Vest":{
            display : {},
            style :{}   
        },
        "Shirt":{
            display : {},
            style :{}   
        },
        "Pant":{
            display : {},
            style :{}   
        },
        "Kurta":{
            display : {},
            style :{}   
        },
        "Pajama":{
            display : {},
            style :{}   
        },
        "Sadri":{
            display : {},
            style :{}   
        }
    })

    const fabricIcons = useMemo(()=>[
        {des:"Composition","attr":"material", "typ":0},
        {des:"Color", "attr":"color", "typ":1},
        {des:"Pattern", "attr":"pattern", "typ":0},
        {des:"Weave", "attr":"weave", "typ":1},
        {des:"Width", "attr":"width", "typ":1}
    ], [])
    const [sel, setSel] = useState( info ?  decodeObj(info) : null)

    // Realtime Data Fetching for Custom Uploads
    useEffect(() => {
        const fetchFreshData = async () => {
            if (!sel || !category) return;
            
            // Determine the collection and type
            // Suit -> Coat (in Suits collection), Kurta -> Kurta (in kurta collection)
            const type = category === "suit" ? "Coat" : "Kurta"; 
            
            if (!sel.fabric || !sel.fabric[type] || !sel.fabric[type].id) return;

            const styleID = sel.fabric[type].id;
            const collName = category === "suit" ? "Suits" : "kurta";
            const docName = category === "suit" ? "Coat" : "Kurta"; 

            // Prevent infinite loop if data is already fresh
            // Check if sel already has the expected fields and they match? 
            // Hard to check exact match without fetching, but we can check existence.
            // For now, we fetch and merge. React state updates only trigger re-render if value changes.

            try {
                const docRef = db.collection("Fabric").doc(collName).collection(docName).doc(styleID);
                const docSnap = await docRef.get();
                
                if (docSnap.exists) {
                    const freshData = docSnap.data();
                    console.log("Fetched fresh data for realtime update:", freshData);
                    
                    setSel(prev => {
                        if (!prev) return prev;

                        // Define keys that belong to standard Kurta layers to be wiped
                        const KURTA_LAYER_KEYS = [
                            "BE", "BKC", "BKN", "BPL", "BPR", "CB", "CC", "CE", "CM", "CN", "CR", "CS", "CT", "D", 
                            "FLN", "FLR", "FLS", "FRN", "FRR", "FRS", "LN", "LR", "LS", "NH0", "NS0", "NS3", "NS4", 
                            "QH0", "QS0", "QS3", "QS4", "R-COAT", "R-SADRI", "R", "RN", "RR", "RS", "S-COAT", 
                            "S-SADRI", "S", "SC-SADRI", "SC", "SE", "SN-SADRI", "SN", "T"
                        ];

                        // Create a shallow copy of previous styles
                        let cleanStyles = { ...(prev.styles || {}) };

                        // If we have fresh display_images (renders) OR a custom model, wipe old Kurta layer keys
                        // This prevents "Ghosting" where old layers (like 'Base') remain because the new upload didn't overwrite them
                        const isCustomUpdate = (freshData.display_images && Object.keys(freshData.display_images).length > 0) || freshData.modelSrc;

                        if (isCustomUpdate) {
                            KURTA_LAYER_KEYS.forEach(key => {
                                // Delete from previous state
                                if (cleanStyles[key]) {
                                    delete cleanStyles[key];
                                }
                                // CRITICAL: Also delete from freshData.styles if they exist there
                                // This handles cases where the DB still has old layer references alongside new modelSrc
                                if (freshData.styles && freshData.styles[key]) {
                                    delete freshData.styles[key];
                                }
                            });
                        }

                        // Merge fresh styles and display_images (renders) into the cleaned styles
                        const mergedStyles = {
                            ...cleanStyles,
                            ...(freshData.styles || {}),
                            ...(freshData.display_images || {}) 
                        };

                        // Avoid unnecessary updates if key data hasn't changed
                        if (prev.modelSrc === freshData.modelSrc && 
                            prev.handsSrc === freshData.handsSrc &&
                            Object.keys(prev.styles || {}).length === Object.keys(mergedStyles).length) {
                            return prev;
                        }

                        return {
                            ...prev,
                            // STRICTLY update these fields from freshData. 
                            // If they are missing in freshData, set to null to clear any stale data from prev.
                            modelSrc: freshData.modelSrc || null,
                            handsSrc: freshData.handsSrc || null,
                            handsCuffSrc: freshData.handsCuffSrc || null,
                            handsNonCuffSrc: freshData.handsNonCuffSrc || null,
                            styles: mergedStyles,
                            second_images: freshData.second_images || null
                        };
                    });
                }
            } catch (error) {
                console.error("Error fetching fresh data:", error);
            }
        };

        fetchFreshData();
    }, [sel?.fabric?.Kurta?.id, sel?.fabric?.Coat?.id, category]); // Run when ID changes

    const [FabricTypes, setFabricTypes] = useState()
    const [fabricType,setType ] = useState("")

    const [hoverDetils, setHoverDets] = useState({})
    const [sHover, setHover] = useState(-2)
    const [edit , setEdit] = useState(false)

    const [hDes, setHdes] = useState(true)
    const [himg, setHimg] = useState(0)

    const [menuOpen2, setMenuOpen2] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuOpenEmb, setMenuOpenEmb] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    const [types, setTyp] = useState([1, 0, 0, 1])

    const [imgState, setImgState] = useState(
        0
    )

    const [mess, setMess] = useState(true);
    const [useFilter, setFilter] = useState(fabricFilter);

    const [fabricList, setFabricsList] = useState([])
    const [currentFilters, setCurrentFilters] = useState({})
    const [showFilter, setShowFilter] = useState(false)
    
    const [Buttons, setButtons] = useState([])
    const [Tuxedo, setTuxedo] = useState([])
    const [embroidery, setEmbroidery] = useState([])
    const [ embroideryStyle, setEmbroideryStyle] = useState([])

    const [openButtonSelection, setOpenButtonSelection] = useState(null);

    // set this to button or tuxedo for the respective item selection
    const [selectStyleItem, setSelectStyleItem] = useState(null);

    const [embHoverDetails, setEmbHoverDetails] = useState(null);

    const [currBody, setCurrBody] = useState(null);

    const select = (key, typ = null)=>{
        // if(key === 1 || key === 3){

            var a = [...types]

            a[key] = Number(!a[key])

            if(category === "kurta"){
                if(a[1] === 1 && a[1] === a[3]){
                    if(key === 1){
                        a[3] = 0
                    } else {
                        a[1] = 0
                    }
                }
            } 

            if(typ){
                a[key] = typ
            }
            setTyp(a)
        // }
    }
    /// main function to set rules and initiate vars
    const initiateSel = ()=>{
        // suit , pant , shirt , formal , blazer
        // console.log("Catr : ", category)
        const ss = decodeObj(info)
        let sel_from_storage;
        if(ss){
            // console.log("coming here and good", ss)
            sel_from_storage = {...ss}
        } else {
            // console.log("fuck up");
        }
        // console.log("bef initialize", sel_from_storage, sel_from_storage.state)
        if(!sel_from_storage){
            sel_from_storage = {...sel}
            setImgState(0)

            sel_from_storage["types"] = Object.keys(Types[category])
            sel_from_storage["types"] = sel_from_storage["types"].filter(function(e) { return e !== 'measurement' })

            var fabric = {}
            sel_from_storage.types.forEach((e)=>{
                fabric[e] = {
                    "brand":"" ,
                    "name":"" ,
                    "price":"" ,
                    "src":"" ,
                    "pos":Types[category][e]
                }
            })
            sel_from_storage["fabric"] = fabric;
            sel_from_storage.state = 1;
            // this is a custom - fromal, shirt ....
        } else if(sel_from_storage && sel_from_storage.types && sel_from_storage.state === 0){
            // this is a custom suit, kurta
            
            if(category === "kurta" && (sel_from_storage.types.includes("Coat") || sel_from_storage.types.includes("Sadri"))){
                setImgState(-1)
            } else {
                setImgState(0)
            }
            var fabric = {}
            sel_from_storage.types.forEach((e)=>{
                fabric[e] = {
                    "brand":"" ,
                    "name":"" ,
                    "price":"" ,
                    "src":"" ,
                    "pos":Types[category][e]
                }
            })
            sel_from_storage["fabric"] = fabric;

            sel_from_storage.state = 1;
            
        } else {
            // preset or a build up custom
            sel_from_storage.state = 2;
        }

        
        
        
        sel_from_storage["category"] = category;
        var fin = {}
        Object.keys(sel_from_storage.fabric).forEach((e)=>{
            fin[e] = {
                display : {},
                style :{}   
            }
        })
        setStylesAll(fin)
        
        
        setFabricTypes(sel_from_storage.types)

        return sel_from_storage;
    }


    const getFabricDetails1 = async(id, attr = "id")=>{

        // /Fabric/Suits/fabrics
        // const coll = db.collection("Fabric").doc("Suits").collection("fabrics")
        const collName = ["suit", "formal"].includes(category) ? "Suits" : "kurta"
        const coll = db.collection("Fabric").doc(collName).collection("fabrics")

        let data = []
        if(id){
            data  = await getDocOnCondition(coll,attr, id )
            return data[0]
        } else {
            data  = await getData(coll)
            return data
        }
    }

    // function backMove () {
    //     // console.log("Curr nav", nav)
    //     if(section === 0){
    //         // console.log("executing this")
    //         setNav((curr)=> curr-1)
    //     } else {
    //         // console.log("executing 0")
    //         setSection(0)
    //     }
    // }
    const counter = useRef(0)

    const imageLoaded = (c = 1) => {
        counter.current += 1;
        let L = 1;
        
        if (counter.current >= L) {
            // console.log("Removing")
            setFabricInfoLoad(false);
            counter.current = 0;
        }
    }

    const setFilters = (useFabric)=>{
        console.log("setting the filter", useFabric)
        const pattern = {}
        const colors = {}
        const material = {}
        const ocassion = {}
        if(useFabric.length){
            
            const res = extractUniqueFabricAttributes({fabrics : useFabric})
            const newF = []
            Object.keys(res).map((k)=>{
                newF.push(
                    {
                        type : k, 
                        q : res[k].q,
                        attr : res[k].attrs 
                    }
                )
            })
            console.log(res, newF)
            setFilter(
                [...useFilter, ...newF]
            )

        } else {
            console.log("issue", useFabric)
        }
    }

    useEffect(()=>{
        if(category){
            if(Body_config[category] && Body_config[category].length > 0){
                setCurrBody( Body_config[category][0]  )
            } else {
                console.log("No body config for ", category)
            }
        }
    }, [category])

    useEffect(()=>{
        console.log("Fabrics_all changing ", Fabrics_all)
        if(Fabrics_all && Object.keys(Fabrics_all).length > 0){
            // fetch all the unique fabric IDs
            let fabIDs = new Set()
            Object.keys(Fabrics_all).map((k)=>{
                Fabrics_all[k].map((val)=>{
                    fabIDs.add(val.fabricID)
                })
            })
            fabIDs = Array.from(fabIDs)
            console.log("Fabric IDs", fabIDs);

            // get the fabrics from query
            const collName = ["suit", "formal"].includes(category) ? "Suits" : "kurta"
            // const collref = db.collection("Fabric").doc(collName).collection("fabrics")
            // const collref = db.collection("Fabric").doc("Suits").collection("fabrics")
            getDocsFromQueryForFabrics(collName, fabIDs).then((data)=>{
                console.log("returning from query ", data);
                setFabricsList(data)
                setFilters(data)
            })
        }
    }, [Fabrics_all])

    useEffect(()=>{
        if(currBody && currBody.id !== 0){
            console.log("Body changing, getting styles again")
            getStyleImg().then(()=>{});
        }
    }, [currBody])

    useEffect(()=>{
        // filter based on the fabrics list all variable

        // setUseFabric to only ids of the above filter result
        
        if(Fabrics_all && Object.keys(Fabrics_all).length > 0 && fabricList.length > 0 && currentFilters && Object.keys(currentFilters).length > 0){
            console.log("filter changing ", currentFilters)
            const res = applyFilters(fabricList, currentFilters, Fabrics_all, sel, getStyleImg ,category )
            console.log("after filters are applied", useFabric, res)
            setUseFabric(res)
        }
        // setSel to the first one -- how to do it on same fabric
    }, [fabricList, currentFilters, Fabrics_all])

    /// for changing the fabric selection state on image change
    useEffect(()=>{
        if(FabricTypes){
            if(category === "suit"){
                if(imgState <=2){
                    setType("Coat")
                }else{
                    if(FabricTypes.includes("Shirt")){
                        if(imgState === 3){
                            setType("Shirt")
                        } else if(imgState <= 5){
                            setType("Pant")
                        } else{
                            setType("Vest")
                        }
    
                        
                    }else{
                        if(imgState <= 4){
                            setType("Pant")
                        } else{
                            setType("Vest")
                        }
                        
                    }
                }
            } else if(category === "formal"){
                if(imgState <=2 ){
                    setType("Shirt")
                } else {
                    setType("Pant")
                }
            }
        }
        
    }, [imgState])

    useEffect(()=>{
        const element = document.getElementById(`style_type_${fabricType}`);
        element?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
    }, [fabricType])

    useEffect(()=>{
        if(sel && sel.fabric && sel.fabric[fabricType]){
            const fab_to = `fabriclist_${sel.fabric[fabricType].brand}_${sel.fabric[fabricType].fabric}`.replace(" ", "")
            const element = document.getElementById(fab_to);
            element?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        }
        
    }, [sel, fabricType])

    


    //// for fabric details on fabric info click
    useEffect(()=>{
        
        if( hoverDetils && Object.hasOwn(hoverDetils, "q")){
            setFabricInfoLoad(true)
            getFabricDetails1(hoverDetils["q"], "fabricID").then((data)=>{  
                if(!data){
                    return getFabricDetails1(hoverDetils["q"], "id")
                }
                return data
            }).then((data)=>{
                if(!data){
                    setFabricInfoLoad(false)
                    return
                }
                var Data = {...data}
                if(!Data.name && Data.fabric) Data.name = Data.fabric
                if(!Data.fabric && Data.name) Data.fabric = Data.name
                if(Array.isArray(Data.color)){
                    Data.color = Data.color.filter(Boolean).join(", ")
                }
                setHoverDets((prev)=>({
                    ...prev,
                    ...Data,
                    name: Data.name || prev.name || "",
                    brand: Data.brand || prev.brand || "",
                    brandImg: Data.brandImg || prev.brandImg || "",
                    des: Data.des || prev.des || "",
                    src: Data.src || prev.src || "",
                    single: Array.isArray(Data.single) ? Data.single : (Array.isArray(prev.single) ? prev.single : [])
                }))
                setFabricInfoLoad(false)
            }).catch((e)=>{
                setFabricInfoLoad(false)
            })
        }
    }, [hoverDetils])


    const getStyleImg = async(inp = null, l = 0, types = null)=>{
        try{
            // setOn(0)
            // console.log("start of get Styles")
            console.log("came to get style img");
            setLoading(true)
            var Obj = {}
            if(inp){
                Obj = {...inp}
                console.log("THIS IS BEING USED :", Obj)
            }else {
                Obj = {...sel}
            }
            // console.log("Object received", Obj)
            // console.log("THIS IS BEING USED :", Obj)
            // var Obj = {...sel}
            let styles = Obj.style

            var styleTypes = []
            if(types){
                styleTypes = types
            } else {
                styleTypes = Object.keys(styles)            
            }
            
            
            // let Obj = {...sel}
            var StylesALL = {
                "Coat":{
                    display : {},
                    style :{}
                },
                "Vest":{
                    display : {},
                    style :{}
                },
                "Shirt":{
                    display : {},
                    style :{}
                },
                "Pant":{
                    display : {},
                    style :{}
                },
                "Kurta":{
                    display : {},
                    style :{}
                },
                "Pajama":{
                    display : {},
                    style :{}
                },
                "Sadri":{
                    display : {},
                    style :{}
                },
                "Tuxedo":{
                    display : {},
                    style :{}
                },
                "Buttons" : {
                    display : {},
                    style :{}
                }
            }
            if(!inp){
                // console.log("setting styles all from this shit, ", STYLESALL)
                StylesALL = {...STYLESALL}
            }
            // console.log("before , ", StylesALL)
            // console.log("Styles: ", StylesALL)
            for(let j = 0;j<styleTypes.length;j++){
                console.log("Running for ", styleTypes[j]);
                Obj["fabric"][styleTypes[j]]["single"] = []

                const coll  = category === "suit" ? "Suits" 
                    : category === "formal" || category === "pant" || category === "shirt" ? "formal"
                    : category === "kurta" ? "kurta" 
                    : category === "blazer" ? "blazer"
                    : category === "sadri" ? "kurta"
                    : "dummy" ;

                const refString = `Fabric/${coll}/${styleTypes[j]}_style/${Obj["fabric"][styleTypes[j]]["id"]}`
                const refString_buttons = `Buttons/${Obj["button"] ? Obj["button"].id : Buttons[0].id}`

                let refString_tuxedo = `Fabric/${coll}/tuxedo/default`
                if(Obj["tuxedo"]){
                    refString_tuxedo = refString_tuxedo.split("/").slice(0, -1).join("/") + "/" + Obj["tuxedo"]["id"]
                }
                const ref = db.doc(refString)
                const ref_buttons = db.doc(refString_buttons)
                const ref_tuxedo = db.doc(refString_tuxedo)

                console.log("crodssed configs");
                // Obj["fabric"][styleTypes[j]]["style"]
                // console.log(styleTypes[j], "this is what its taking from ", Obj["fabric"][styleTypes[j]])
                // console.log("ref", ref)
                
                let Doc = styles[styleTypes[j]]
                for(let k = 0;k<Object.keys(Doc).length;k++){
                    const element = Object.keys(Doc)[k]

                    var name = ""
                    
                    Doc[element].forEach((id)=>{
                        if(id.length){
                            name+=id+"-"
                        }
                        
                    })
                    if(Doc[element].length === 1){
                        name = Doc[element][0]
                    }
                    if (name[name.length - 1] === "-") {
                        name = name.slice(0, name.length - 1);
                        // console.log("comging here to fix", name.slice(0, name.length - 1))
                    }
                    
                    
                    //// Rules
                    if(styleTypes[j] === "Pant"){

                        if(name.includes("-C-H")){ name = name.slice(0, name.length-4) }
                    }

                    if(styleTypes[j] === "Pajama"){
                        if(name.includes("PP")){ name = "PP" }
                    }
                    
                    
                    if(styleTypes[j] === "Shirt"  ){

                        // [ "BASE", "P1", "SS", "F", "N"]

                        // const temp_name = name;

                        const L = name.split("-")
                        // L[0] = L[0]+"-"+L[3]

                        let tot = L.length
                        if(L.includes("H")){
                            // this is the place
                            L[L.length-1] = "0"
                        } else {
                            L[L.length-2] = "SLEVE"
                        }
                        let check = -1
                        if(L[L.length-1] === "C"){
                            check = L.length-2
                        }
                        let shirtImgs = []
                        for(let m = 0;m<tot;m++){
                            if(L[m] !="0" && (m!=check) ){
                                // console.log("Shirt running for : ",L[m])
                                if(StylesALL[styleTypes[j]]["style"] && !Object.hasOwn(StylesALL[styleTypes[j]]["style"], L[m])){
                                    // console.log("Shirt : ", ref, L[m], Obj["fabric"][styleTypes[j]])
                                    const src= (await getDatafromDoc(ref.collection("style").doc(L[m])))["src"]
                                    if(src && src.length > 0){
                                        StylesALL[styleTypes[j]]["style"][L[m]] = src 
                                    }                                    
                                } 

                                shirtImgs.push(StylesALL[styleTypes[j]]["style"][L[m]])
                            }
                        }
                        Obj["fabric"][styleTypes[j]]["single"].push({
                            "typ": 1,
                            "src": shirtImgs
                        });

                        if(category === "suit" && element === "F"){
                            const isJ = Obj["style"]["Coat"]["F"][0][0] === "J" ? true : false;
                            let shirt = "SHIRT"
                            if(isJ){
                                shirt = "SHIRT-J"
                            }
                            if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], shirt)){
                                // console.log("Shirt : ", ref, shirt, Obj["fabric"][styleTypes[j]])
                                const src= (await getDatafromDoc(ref.collection("display").doc(shirt)))["src"]
                                if(src && src.length > 0){
                                    StylesALL[styleTypes[j]]["display"][shirt] = src 
                                }                                    
                            } 

                            Obj["fabric"][styleTypes[j]]["src"] = StylesALL[styleTypes[j]]["display"][shirt]
                            
                        }
                    }

                    if(styleTypes[j] === "Kurta"){
                        

                        // [ "R", "NS3", "00","R","0", "R", "SE" ,"CM","SN", "US1" ]
                        
                        // console.log("Kurta Start")

                        var L = name.split("-")
                        let tot = L.length
                        
                        // Use original tokens from selection
                        let check = -1
                        
                        let shirtImgs = []

                        
                        for(let m = 0;m<tot;m++){
                            if( !/^0+$/.test(L[m]) && (m!=check) && L[m] != "BPL" ){
                                // console.log("Kurta Style running for : ", L[m], StylesALL[styleTypes[j]]["style"] , !Object.hasOwn(StylesALL[styleTypes[j]]["style"], L[m]))
                                if(StylesALL[styleTypes[j]]["style"] && !Object.hasOwn(StylesALL[styleTypes[j]]["style"], L[m])){
                                    
                                    
                                    const src= (await getDatafromDoc(ref.collection("style").doc(L[m])))
                                    if(!src || !src.src || ( src.src && src.src.length === 0 )){
                                        // console.log("Style not available", L[m])
                                    } else {
                                        
                                        StylesALL[styleTypes[j]]["style"][L[m]] = src["src"]
                                        shirtImgs.push(StylesALL[styleTypes[j]]["style"][L[m]])
                                    }
                                } else {
                                    
                                    shirtImgs.push(StylesALL[styleTypes[j]]["style"][L[m]])
                                } 
                            }
                        }

                        
                        Obj["fabric"][styleTypes[j]]["single"].push({
                            "typ": 1,
                            "src": shirtImgs
                        });

                        const display_shirt = []
                        //// display images for kurta
                        
                        for(let m = 0;m<tot;m++){
                            
                            if( !/^0+$/.test(L[m]) && L[m] != "CA" ){
                                if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], L[m])){
                                    // console.log("Shirt : ", ref, L[m], Obj["fabric"][styleTypes[j]])
                                    
                                    const src= (await getDatafromDoc(ref.collection("display").doc(L[m])))
                                    if(!src || !src.src || ( src.src && src.src.length === 0 )){
                                        // console.log("display not available", L[m])
                                    } else {
                                        StylesALL[styleTypes[j]]["display"][L[m]] = src["src"]
                                        display_shirt.push( StylesALL[styleTypes[j]]["display"][L[m]] )
                                    }                                    
                                } else {
                                    display_shirt.push( StylesALL[styleTypes[j]]["display"][L[m]] )
                                }

                                
                            }
                            // if(["R", "S", "D", "T"].includes(L[m])){
                            //     display_shirt.push( kurta_hand_k)   
                            // }
                        }
                        Obj["fabric"][styleTypes[j]]["src"] = display_shirt


                        /// default kurta when coat and sadri

                        if(Obj.types.includes("Coat") || Obj.types.includes("Sadri")){

                            const defaults = []

                            const extra = Obj.types.includes("Coat") ? "COAT" : "SADRI"

                            var def_name = Obj.style.Kurta.F[0]+"-"+extra

                            // console.log("fetching default for Kurta",def_name)

                            if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], def_name)){
                                
                                
                                const src= (await getDatafromDoc(ref.collection("display").doc( def_name )))

                                if(!src || !src.src || ( src.src && src.src.length === 0 )){
                                    // console.log("display not available", def_name)
                                } else {
                                    StylesALL[styleTypes[j]]["display"][def_name] = src["src"]
                                    defaults.push( src.src )
                                }                                    
                            } else {
                                defaults.push( StylesALL[styleTypes[j]]["display"][def_name] )
                            }
                            if(extra === "SADRI"){
                                
                                def_name = Obj.style.Kurta.F[8]+"-"+extra

                                if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], def_name)){
                                
                                
                                    const src= (await getDatafromDoc(ref.collection("display").doc( def_name )))
    
                                    if(!src || !src.src || ( src.src && src.src.length === 0 )){
                                        // console.log("display not available", def_name)
                                    } else {
                                        StylesALL[styleTypes[j]]["display"][def_name] = src["src"]
                                        defaults.push( src.src )
                                    }                                    
                                } else {
                                    defaults.push( StylesALL[styleTypes[j]]["display"][def_name] )
                                }
                            }

                            Obj["fabric"][styleTypes[j]]["default"] =  defaults
                        }   


                        // console.log("Kurta End")
                    }

                    if(styleTypes[j] === "Sadri"){
                        var L = name.split("-")
                        let tot = L.length

                        L.push("B"+L[0])
                        if(L[1] === "1"){
                            L[1] = "0"
                            L.push("V"+L[0])
                        }

                        tot = L.length
                        // console.log("Sadri final names", L)
                        
                        let check = -1
                        
                        let shirtImgs = []

                        
                        for(let m = 0;m<tot;m++){
                            if( !/^0+$/.test(L[m]) && (m!=check) ){
                                // console.log("Kurta Style running for : ", L[m], StylesALL[styleTypes[j]]["style"] , !Object.hasOwn(StylesALL[styleTypes[j]]["style"], L[m]))
                                if(StylesALL[styleTypes[j]]["style"] && !Object.hasOwn(StylesALL[styleTypes[j]]["style"], L[m])){
                                    
                                    
                                    const src= (await getDatafromDoc(ref.collection("style").doc(L[m])))
                                    if(!src || !src.src || ( src.src && src.src.length === 0 )){
                                        // console.log("Style not available", L[m])
                                    } else {
                                        
                                        StylesALL[styleTypes[j]]["style"][L[m]] = src["src"]
                                        shirtImgs.push(StylesALL[styleTypes[j]]["style"][L[m]])
                                    }
                                } else {
                                    
                                    shirtImgs.push(StylesALL[styleTypes[j]]["style"][L[m]])
                                } 
                            }
                        }

                        
                        Obj["fabric"][styleTypes[j]]["single"].push({
                            "typ": 1,
                            "src": shirtImgs
                        });

                        const display_shirt = []
                        //// display images for kurta
                        
                        for(let m = 0;m<tot;m++){
                            
                            if( !/^0+$/.test(L[m])){
                                if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], L[m])){
                                    // console.log("Shirt : ", ref, L[m], Obj["fabric"][styleTypes[j]])
                                    
                                    const src= (await getDatafromDoc(ref.collection("display").doc(L[m])))
                                    if(!src || !src.src || ( src.src && src.src.length === 0 )){
                                        // console.log("display not available", L[m])
                                    } else {
                                        StylesALL[styleTypes[j]]["display"][L[m]] = src["src"]
                                        display_shirt.push( StylesALL[styleTypes[j]]["display"][L[m]] )
                                    }                                    
                                } else {
                                    display_shirt.push( StylesALL[styleTypes[j]]["display"][L[m]] )
                                }

                                
                            }
                            if(m === 3){
                                // display_shirt.push( L[m] === "F" ? wrist : hands  )
                            }
                        }
                        Obj["fabric"][styleTypes[j]]["src"] = display_shirt

                        // console.log("Sadri complete")
                    }

                    if(styleTypes[j] === "Vest"){
                        const Layers = getVestLayers(element,ref, ref_buttons, name, Obj, ref_tuxedo);
                        // console.log("Layers for Vest ", Layers);
                        let display_images = []
                        let style_images  = []

                        // fetch all layers of style images for vest
                        for(let layer=0;layer<Layers.length;layer++){
                            const types_vest = Layers[layer]["types"];
                            for(let i1=0;i1<types_vest.length;i1++){
                                const type_vest = types_vest[i1];
                                let coll_type = null;
                                if(Layers[layer].fromStyle){
                                    coll_type = "style"
                                }
                                if(Layers[layer] !== "0"){
                                    // console.log("Vest Style running for : ", Layers[layer], StylesALL[styleTypes[j]]["style"] , !Object.hasOwn(StylesALL[styleTypes[j]]["style"], Layers[layer]))
                                    if(StylesALL[styleTypes[j]][type_vest] && !Object.hasOwn(StylesALL[styleTypes[j]][type_vest], Layers[layer]["name"])){
                                        
                                        const src= (await getDatafromDoc(Layers[layer]["col"].collection(coll_type ? coll_type : type_vest).doc(Layers[layer]["name"])))
                                        if(!src || !src.src || ( src.src && src.src.length === 0 )){                            
                                            console.log(Layers[layer]["col"],coll_type, type_vest, Layers[layer]["name"]);
                                            console.log(type_vest + " not available", Layers[layer]["name"])
                                        } else {
                                            
                                            StylesALL[styleTypes[j]][type_vest][Layers[layer]["name"]] = src["src"]
                                            if(type_vest === "display"){
                                                display_images.push(StylesALL[styleTypes[j]][type_vest][Layers[layer]["name"]])
                                            }
                                            else {
                                                style_images.push(StylesALL[styleTypes[j]][type_vest][Layers[layer]["name"]])
                                            }
                                            
                                        }
                                    } else {
                                        if(type_vest === "display"){
                                            display_images.push(StylesALL[styleTypes[j]][type_vest][Layers[layer]["name"]])
                                        }
                                        else {
                                            style_images.push(StylesALL[styleTypes[j]][type_vest][Layers[layer]["name"]])
                                        }
                                    } 

                                }
                            }
                        }

                        if(element === "F"){
                            Obj["fabric"][styleTypes[j]]["src"] = [...display_images]
                        }
                        
                        Obj["fabric"][styleTypes[j]]["single"].push(
                            {
                                "typ": 1,
                                "src": [ ...style_images ]
                            }
                        );

                    }

                    if(styleTypes[j] === "Coat"){
                        // rules
                        if((name[0] === "4" || name[0] === "6") && Obj["style"]["Coat"]["F"][1] === "N"){
                            // console.log("Changing the default lapel")
                            Obj["style"]["Coat"]["F"][1] = "P"
                            
                            // name = name.slice(0, 2) + "P"+ name.slice(4)
                        }

                        

                        let display_images = []
                        let style_images  = []

                        console.log("Coat, ", name)

                        const layers = getCoatLayers(element,ref, ref_buttons, name, Obj, ref_tuxedo);
                        console.log("Layers for coat ", layers, element);



                        // fetch all layers of style images for coat
                        for(let layer=0;layer<layers.length;layer++){
                            const types_coat = layers[layer]["types"];
                            for(let i1=0;i1<types_coat.length;i1++){
                                const type_coat = types_coat[i1];
                                let coll_type = null;
                                if(layers[layer].fromStyle){
                                    coll_type = "style"
                                }
                                if(layers[layer] !== "0"){
                                    // console.log("Coat Style running for : ", layers[layer], StylesALL[styleTypes[j]]["style"] , !Object.hasOwn(StylesALL[styleTypes[j]]["style"], layers[layer]))
                                    if(StylesALL[styleTypes[j]][type_coat] && !Object.hasOwn(StylesALL[styleTypes[j]][type_coat], layers[layer]["name"])){


                                        const src= (await getDatafromDoc(layers[layer]["col"].collection(coll_type ? coll_type : type_coat).doc(layers[layer]["name"])))
                                        if(!src || !src.src || ( src.src && src.src.length === 0 )){
                                            console.log(type_coat + " not available", layers[layer]["name"])
                                        } else {
                                            
                                            StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]] = src["src"]
                                            if(type_coat === "display"){
                                                display_images.push(StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]])
                                            }
                                            else {
                                                style_images.push(StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]])
                                            }
                                            
                                        }
                                    } else {
                                        if(type_coat === "display"){
                                            display_images.push(StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]])
                                        }
                                        else {
                                            style_images.push(StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]])
                                        }
                                    } 

                                }
                            }
                        }

                        console.log("Final Coat Style images", style_images)
                        console.log("Final Coat Display images", display_images)
                        if(element === "F"){
                            Obj["fabric"][styleTypes[j]]["src"] = [...display_images]
                        }
                        
                        Obj["fabric"][styleTypes[j]]["single"].push(
                            {
                                "typ": 1,
                                "src": [ ...style_images ]
                            }
                        );
                    }

                    // pant display image for Coat
                    if(category === "suit" && element === "F" && styleTypes[j] === "Pant"){
                        const display_pant_name = Obj.style.Pant.F[0];
                        if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], display_pant_name)){   
                            // console.log("Fetching for pant display image ", display_pant_name)
                            const src = (await getDatafromDoc(ref.collection("display").doc(display_pant_name)))["src"];
                            if(src && src.length > 0){
                                StylesALL[styleTypes[j]]["display"][display_pant_name] = src;   
                            }
                        }

                        Obj["fabric"][styleTypes[j]]["src"] = StylesALL[styleTypes[j]]["display"][display_pant_name];
                    }
                    console.log("After Coat")

                    /// for setting display images for shirt
                    if( ( category === "shirt" || ( category === "formal" && styleTypes[j] === "Shirt" ) ) && element === "F" ){

                        const display_shirt = []

                        const L = name.split("-")
                        // console.log("Display images for shirt")
                        // console.log(L)

                        // change base if mandrian is selected
                        if(L[2] === "0"){
                            L[0] = "M0"
                        }
                        let tot = L.length
                        // [ "BASE", "P1", "SS", "F", "N"]\
                        L[0] = L[0]+"-"+L[3]
                        

                        L[3] = "0"
                        for(let m = 0;m<tot-1;m++){
                            
                            if(L[m] !="0"){
                                if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], L[m])){
                                    // console.log("Shirt : ", ref, L[m], Obj["fabric"][styleTypes[j]])
                                    const src= (await getDatafromDoc(ref.collection("display").doc(L[m])))["src"]
                                    if(src && src.length > 0){
                                        StylesALL[styleTypes[j]]["display"][L[m]] = src 
                                    }                                    
                                }

                                display_shirt.push( StylesALL[styleTypes[j]]["display"][L[m]] )
                            }
                            
                        }
                        // console.log("Setting Wrist :", L[0], L[0][L[0].length-1], L[0][L[0].length-1] === "F");
                        display_shirt.push( L[0][L[0].length-1] === "F" ? currBody.wrist : currBody.hands  ) 
                        Obj["fabric"][styleTypes[j]]["src"] = display_shirt

                    }

                    if (StylesALL[styleTypes[j]]["style"] && !Object.hasOwn(StylesALL[styleTypes[j]]["style"], name) && styleTypes[j] !== "Shirt" && styleTypes[j] !== "Kurta" && styleTypes[j] !== "Sadri" && styleTypes[j] !== "Coat") {
                        console.log("Fetching for ", name, " in ", styleTypes[j])
                        if (name && name.length > 0) {
                            const src = (await getDatafromDoc(ref.collection("style").doc(name)))["src"];
                            
                            // console.log("Pajama Style img", name, src)
                            if (src && src.length > 0) {
                                StylesALL[styleTypes[j]]["style"][name] = src;
                            }
                        }
                    }
                    
                    // / for changing the display image based on style
                    if((category === "pant" || (category === "formal" && styleTypes[j] === "Pant")) && name[0] === "F"){

                        // console.log("coming in here for suit also")
                        if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], name)){   
                            if (name && name.length > 0) {
                                const src = (await getDatafromDoc(ref.collection("display").doc(name)))["src"];
                                // console.log("from display for ", name, src)
                                if (src && src.length > 0) {
                                    StylesALL[styleTypes[j]]["display"][name] = src;
                                }
                            }
                        }

                        
                        Obj["fabric"][styleTypes[j]]["src"] = StylesALL[styleTypes[j]]["display"][name]
                        
                    }

                    

                    if (styleTypes[j] !== "Shirt" && styleTypes[j] !== "Kurta" && styleTypes[j] !== "Sadri" && styleTypes[j] !== "Coat" && styleTypes[j] !== "Vest") {

                        if(styleTypes[j] === "Pajama"){
                            Obj["fabric"][styleTypes[j]]["single"].push({
                                "typ": 1,
                                "src": [ pajama_body , StylesALL[styleTypes[j]]["style"][name]]
                            });
                        } else {
                            Obj["fabric"][styleTypes[j]]["single"].push({
                                "typ": 0,
                                "src": StylesALL[styleTypes[j]]["style"][name]
                            });
                        }
                        
                    }

                    if(styleTypes[j] === "Pajama"){
                        name = name.split("-")[0]
                        if(StylesALL[styleTypes[j]]["display"] && !Object.hasOwn(StylesALL[styleTypes[j]]["display"], name)){   
                            if (name && name.length > 0) {
                                const src = (await getDatafromDoc(ref.collection("display").doc(name)))["src"];
                                // console.log("from display for ", name, src)
                                if (src && src.length > 0) {
                                    StylesALL[styleTypes[j]]["display"][name] = src;
                                }
                            }
                        }

                        
                        Obj["fabric"][styleTypes[j]]["src"] = StylesALL[styleTypes[j]]["display"][name]
                    }
                }
            }

            if(isEmbEnabled(category) && Obj["embroidery"]){
                Obj = await setEmbroideryImages( Obj, category );
            }

            console.log("its coming here")
            setStylesAll(StylesALL);
            setSel(Obj);
            // console.log("--------------Final sel Object", Obj)
            // setOn(1);
            // sleep(1500)
            if(l === 1 ){
                setLoading(false);
            }

            console.log("Completed all fetching");
            
            return 1;
        } catch (e) {
            // setOn(1);
            setLoading(false);
            // console.log("from style fetching", e);
            return 0;
        }
    };

    function sortByKey(array, key) {
        return array.sort(function(a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    
    const getKey=()=>{
        var s = '';
        Object.keys(sel.fabric).sort().map((e)=>{
            s+= sel.fabric[e].fabricID
        })
        return s
    }
    useEffect(()=>{
        console.log("SEL is getting changed somewhere...", sel)
        if(sel && sel.state ){
            if(sel.from && sel.key){
                const k = getKey()
                
                if(k != sel.key){
                    console.log("Fucked up....................",k, sel.key)    
                    sel["discount_b"] = sel["discount_b"] ? sel["discount_b"] :   (0 + sel.discount);
                    sel.discount = 0;
                }else{
                    sel.discount = Object.hasOwn(sel, "discount_b") ? sel["discount_b"] : sel.discount 
                }
            }
            
            window.history.replaceState(null, "", `/custom/${category}/${id}/${process}/${encodeObj(sel)}`)
            //sessionStorage.setItem('sel', JSON.stringify(sel))
        }
        
    }, [sel])


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 480);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // useEffect(()=>{
    //     console.log("Changin nav :", nav)
    //     if(nav<-1){
    //         navigate("/")
    //     }
    // }, [nav])
    
    // const computeDistount=  (obj)=>{
    //     for
    // }
    useEffect(()=>{
        let i = 0;
        let Single = []
        if(sel && sel.types){

            sel.types.forEach(element => {
                if(sel.fabric[element] && Object.hasOwn(sel.fabric[element], "single")){
                    i += sel.fabric[element]["single"].length
                    sel.fabric[element]["single"].forEach(val =>{
                        if(val["src"]){
                            Single.push(val)
                        }else{
                            Single.push({"src":val, "typ":0})
                        }
                        
                    })
                }
            });

            // Check for second image (Kurta specific logic)
            let hasSecondImage = false;
            if (category === "kurta" && sel && sel.style && sel.style.Kurta && sel.style.Kurta.F) {
                try {
                    const sec = sel.second_images;
                    if (sec) {
                        const sleeve = sel.style.Kurta.F[8]; // SN, SC
                        if (sleeve === "SC") {
                            // Map Cuff Style (F[9]) to Variant (SC_1..SC_6)
                            const cuffStyle = sel.style.Kurta.F[9]; // US1, UR1, etc.
                            const map = { "US1": "SC_1", "UR1": "SC_2", "UN1": "SC_3", "US2": "SC_4", "UR2": "SC_5", "UN2": "SC_6" };
                            const variant = map[cuffStyle];

                            if (variant && sec[variant]) {
                                hasSecondImage = true;
                            } else {
                                // Fallback if mapped variant not found, check any SC image
                                const firstSC = Object.keys(sec).find(k => k.startsWith("SC_") && sec[k]);
                                if (firstSC) hasSecondImage = true;
                            }
                        } else if (sleeve === "SN") {
                            if (sec["SN_DEFAULT"]) hasSecondImage = true;
                        }
                    }
                } catch (e) {
                    // ignore
                }
            }
            
            if (hasSecondImage) {
                i += 1;
            }

            // console.log(Single, i)
            setStates(i)
            setSingle(Single)
        }
        
     }, [sel])

    useEffect(()=>{

        // if(id === Navs[0]){
        //     if(category !="kurta" && category !="suit"){
        //         navigate(`/custom/${category}/${Navs[nav+1]}/${process}`, { replace: true })
        //     }
        // }
        // console.log("this is what u wanted to check");
        
        if(getPage(id) === 1 || process === "customize"){

            // console.log("coming in")

            var Obj_sel = initiateSel()

    
            if(Obj_sel.state === 1 ){
                // setLoading(true)
                var defaultStyle = {
                    "Coat":{
                        "F":["2B", "N", "F", "W", ""],
                        "B":["NV"]
                    },
                    "Pant":{
                        "F":["F-NP", "C", "H"],
                        "B":["B-SP"]
                    },
                    "Vest":{
                        "F":["V1"]
                    },
                    "Shirt":{
                        "F":["BASE", "P1", "SS", "SLEVE", "N"]
                    },
                    "Kurta":{
                        "F" : [ "S", "NS", "00","R","0", "R", "0" ,"CM","SN", "US1" ]
                    },
                    "Pajama":{
                        "F" : [ "PC", "E" ]
                    },
                    // "Pajama":{
                    //     "F" : [ "PJ", "E" ]
                    // },
                    "Sadri":{
                        "F" :["EE", "1"]
                    }
                }

                if(category === "formal" || category === "shirt"){
                    defaultStyle["Shirt"]["B"] = ["A"]
                    defaultStyle["Shirt"]["F"] = [ "BASE", "P1", "SS", "F", "N"]
                }

                // console.log("Types selecetd", FabricTypes)

                // console.log('just printing', Obj_sel)
                getClothAndFabrics(Obj_sel, defaultStyle)
                
            } else if(Obj_sel.state === 2){
                getFabricDetails(Obj_sel.types, category).then((data)=>{
                    var same_fabric = {...data}
                    setFabricsAll(same_fabric)
                    setUseFabric(same_fabric)
                })
                getButtons(category).then((buttons)=>{
                    setButtons(buttons);
                });
                getTuxedo(category).then((tuxedo)=>{
                    setTuxedo(tuxedo);
                });
                getEmbroidery(category).then((embroidery)=>{
                    setEmbroidery(embroidery);
                }); 
                getEmbroideryStyle().then((data)=>{
                    setEmbroideryStyle(data)
                })
                // console.log("calling none")
            } else {
                console.log("coming to no place");
            }
        } else {
            getButtons(category).then((buttons)=>{
                    setButtons(buttons);
                });
            getTuxedo(category).then((tuxedo)=>{
                setTuxedo(tuxedo);
            });  
            getEmbroidery(category).then((embroidery)=>{
                setEmbroidery(embroidery);
            });
            getEmbroideryStyle().then((data)=>{
                setEmbroideryStyle(data)
            })
        }
    }, [id])
    
    const getClothAndFabrics = async(sel_obj, defaultStyle)=>{
        let data = await getFabricDetails(sel_obj.types, category);
        let buttons = await getButtons(category);
        setButtons(buttons);
        getTuxedo(category).then((tuxedo)=>{
            setTuxedo(tuxedo);
        })
        getEmbroidery(category).then((embroidery)=>{
            setEmbroidery(embroidery);
        });
        getEmbroideryStyle().then((data)=>{
            setEmbroideryStyle(data)
        })
        
        console.log("Buttons", buttons);
        
            var same_fabric = {...data}
            var K = Object.keys(same_fabric)

            console.log("getting cloth and fabrics", sel_obj);
            

            // console.log(data)

            let add = {}
            let recom_butt = null;

            if(category === "suit" && (sel_obj.state === 1) ){
                for(let i=0;i< K.length ;i++){
                    if(K[i] !== "Shirt"){
                    same_fabric[K[i]] = sortByKey(same_fabric[K[i]], "fabricID")}
                }

                // console.log("this is the prob")
                const defFabric = data["Coat"][0]["fabricID"]
                // console.log("Sure", defFabric)
                Object.keys(data).forEach((ele)=>{
                    
                    const selectEle = data[ele].find((fabric) => fabric.fabricID === defFabric);
                    
                    if(selectEle){
                        // console.log("found same", selectEle["fabricImg"])
                    }
                    add[ele] = selectEle ? selectEle : data[ele][0]
                    if (add[ele] && Types[category] && Types[category][ele]) {
                        add[ele]["pos"] = Types[category][ele]
                    }
                    if(selectEle && selectEle["recommended_buttons"] && selectEle["recommended_buttons"].length > 0 && !recom_butt){
                        recom_butt =  {...buttons.find((but) => but.id === selectEle["recommended_buttons"][0])}
                    } 
                    
                })

                // console.log("final done")
            } else {
                Object.keys(data).forEach((ele)=>{
                    
                    if(sel_obj.state ===2 && sel_obj){
                        add[ele] = sel_obj.fabric[ele]
                    } else{
                        // Ensure data[ele] exists and has items before accessing index 0
                        add[ele] = (data[ele] && data[ele].length > 0) ? data[ele][0] : {}
                    }
                    if (add[ele] && Types[category] && Types[category][ele]) {
                        add[ele]["pos"] = Types[category][ele]
                    }
                    if(sel_obj.fabric && sel_obj.fabric[ele] && sel_obj.fabric[ele]["recommended_buttons"] && sel_obj.fabric[ele]["recommended_buttons"].length > 0 && !recom_butt){
                        recom_butt =  {...buttons.find((but) => but.id === sel_obj.fabric[ele]["recommended_buttons"][0])}
                    } 
                })
            }
            
            // Setting the button 

            
            setFabricsAll(same_fabric)
            setUseFabric(same_fabric)

            console.log("Came till here");
            

            // console.log("Fabrics", same_fabric)
            
            let defStyle = {}
            
            if(sel_obj.state === 1){
                sel_obj.types.forEach((typ)=>{
                    defStyle[typ] = defaultStyle[typ]
                })
            } else {
                defStyle = sel_obj.style
            }

            // console.log("another one")
            if(!edit){

                let p = 0
                let D = Number(0)
                Object.keys(add).forEach((element)=>{
                    if(add[element] && add[element]["discount"]){
                        const perc = Number(add[element]["discount"])
                        D = D + (Number(add[element]["price"])*( perc/100 ) )
                    }
                    if(add[element] && add[element]["price"]){
                        p+=Number(add[element]["price"])
                    }
                }) 

                // console.log("another 2")
                D = sel_obj.state === 2  ? sel_obj.discount : D
                p = sel_obj.state === 2 ? sel_obj.price : p

                // let price = 0
                // Object.keys(add).forEach((ele)=>{
                //     price+=Number(add[ele]["price"])
                // })
                // // console.log("Initial", add)
                
                // setSel(
                //     {...sel, ...{"fabric":add, "price":p,"discount":D, "style":{...defStyle}}}
                // )
                getStyleImg({...sel_obj, ...{"fabric":add, "price":p,"discount":D, "style":{...defStyle}, "state":sel_obj.state, "button" : recom_butt ? recom_butt : buttons[0] }}).then(()=>{

                })
                // console.log("from Refreshing", {...sel, ...{"fabric":add, "price":p,"discount":D, "style":{...defStyle}}}, defStyle, defaultStyle)
            }
            
            // console.log("printing same fab",same_fabric)
            // FabricTypes.forEach((e)=>{

            //     for(let i=0;i<same_fabric[e].length;i++){

            //         const ele = same_fabric[e][i]
            //         const fabI = ele.fabricID
            //         const selfab = fabrics_list.find((fabric) => fabric.id === fabI);
            //         if(selfab && selfab.id){
            //             same_fabric[e][i]["brand"] = selfab.brand
            //             same_fabric[e][i]["fabric"] = selfab.name
            //             same_fabric[e][i]["fabricImg"] = selfab.src
            //         }
            //     }
                
            // })
            // console.log("From main fabric", same_fabric)
        
    }

    const proceedToViewFabric = () => {
        setNav(1); 
    };
    const proceedToViewFabric2 = () => {
        setNav(-1); 
    };

    // useState(()=>{
    //     const session = JSON.parse(sessionStorage.getItem('sel'))
    //     if(session){
    //         setNav(0)
    //         setFabricTypes(session.types)
    //         setEdit(true)
    //         setSel(session)
    //     }
    // }, [])

    const [mTags, setMtags] = useState()
    useState(()=>{
        var t = {...tags["fabric"]}
        Object.keys(t).map((e)=>{
            if(Array.isArray(t[e])){return}
            t[e] = t[e].replaceAll("replace", category)
            if(e === "url"){
                t[e] = t[e].replaceAll("id", id)
            } 
        })
        setMtags(t)

    }, [id])
    

    return(
        <div className="Fabric"
            style={ ( nav === 1 || nav ===2 || (nav===3 && category==="suit") ) ? {"overflow":"hidden", "height": "100vh"} : { "overflow":"unset", "height": "auto"  }}
        >

            <MetaTags
                data = {mTags}
            />

            
            
            { ((category !="suit" && nav<=2 && nav>0) || (category ==="suit" && nav<=3 && nav>0)) && <div className="s-navigation">
                
                {/* Back Button at the Top */}
                <div className="top-edit-btn" onClick={() => navigate(-1)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5M12 19l-7-7 7-7"/>
                    </svg>
                </div>

                <div className="s-nav_list">
                    {/* Fabric Step */}
                    <div className="nav-icon-container" onClick={() => navigate(`/custom/${category}/${Navs[1]}/${process}/${encodeObj(sel)}`)}>
                        <div className={`nav-icon-box ${nav === 1 ? 'active' : ''}`}>
                            <img src={FabricIcon} alt="Fabric" style={{ width: '24px' }} />
                        </div>
                        <span className="nav-icon-label">Fabric</span>
                    </div>

                    {/* Style Step */}
                    <div className="nav-icon-container" onClick={() => navigate(`/custom/${category}/${Navs[2]}/${process}/${encodeObj(sel)}`)}>
                        <div className={`nav-icon-box ${nav === 2 ? 'active' : ''}`}>
                            <img src={StyleIcon} alt="Style" style={{ width: '28px' }} />
                        </div>
                        <span className="nav-icon-label">Style</span>
                    </div>

                    {/* Embroidery Step */}
                    {isEmbEnabled(category) && (
                        <div className="nav-icon-container" onClick={() => navigate(`/custom/${category}/${Navs[3]}/${process}/${encodeObj(sel)}`)}>
                            <div className={`nav-icon-box ${nav === 3 ? 'active' : ''}`}>
                                <img src={EmbIcon} alt="Embroidery" style={{ width: '28px' }} />
                            </div>
                            <span className="nav-icon-label">Embroidery</span>
                        </div>
                    )}

                    {/* Measurement Step */}
                    <div className="nav-icon-container" onClick={() => {
                        if(process){    
                            navigate(`/measurement/select/${encodeObj(sel)}`)
                        } else {
                            setNav(4)
                        }
                    }}>
                        <div className={`nav-icon-box ${((nav === 3 && category !== "suit") || nav === 4) ? 'active' : ''}`}>
                            <img src={MeasureIcon} alt="Measure" style={{ width: '28px' }} />
                        </div>
                        <span className="nav-icon-label">Measure</span>
                    </div>
                </div>
            </div> }


                {/* //// Logo */}
                {((category !="suit" && nav<=2 && nav >0) || (category ==="suit" && nav<=3 && nav >0)) &&

                <a href="/" style={{textDecoration:"none"}}>
                <div className="s-logo verti_center txt-font"
                    style={{"zIndex":"101"}}
                    onClick={()=>{
                    }}
                    type="button"
                >
                    <img src={logo_name} style={{"width":"150px"}} />
                    
                </div>
                </a>
                }

                {/* //// Indication */}

                { (nav === 1 && indication && sel && sel.types && sel.types.includes("Shirt") ) && <>
                    <div className="f-back-dark"
                        onClick={()=>{
                            if(isMobile){
                                setMenuOpen(0)
                                setMenuOpen2(0)
                            }
                        }}
                    >
                    </div>
                    <div className="indication both_center"
                        onClick={()=>{
                            if(isMobile){
                                setMenuOpen(0)
                                setMenuOpen2(0)
                            }
                        }}
                    >
                        <div style={{"width":"100%", "position":"relative", "height":"100%"}}>
                            Hello Again !! <br/>
                            You are purchasing Shirt and selecting  <b>JodhPuri</b> as your Coat type. 
                            Shirts are not visible with Jodjpuri. You can continue to purchase if you wish to. 
                            <div style={{"display":"flex", "gap":"10px", "fontSize":"0.8rem", "marginTop":"30px"}}>
                            <button className="Butt1" 
                                onClick={()=>{setIndication(false)}}
                            > <span>
                                Continue</span> </button>
                            <button className="Butt1 orange_button" 
                                onClick={()=>{ setNav(-1) }}
                            > <span>Change Selection</span> </button>
                            </div>
                        </div>
                    </div>
                </>
                }

                {selectStyleItem && 
                    <SelectItemDialog
                        getStyleImg = {getStyleImg}
                        setLoad = {setLoading}
                        sel = {sel}
                        type = {selectStyleItem}
                        setType={setSelectStyleItem}
                        category={category}
                        Buttons={Buttons}
                        Tuxedo={Tuxedo}
                    />
                }

                { embHoverDetails && <Emb_modal
                        hoverDetils = {embHoverDetails}
                        setHoverDets = {setEmbHoverDetails}
                    />
                    }

                
                

            
            {
            
            nav === 0 ? (<div className="SelectionBody"
                style={nav!=null && nav === 0 ?{background:"white", "width":"100%", "flexDirection":"column"}:{}}
            >
                
                {(nav!=null && nav === 0) && (
                    <ClothSelect
                    isMobile  = {isMobile}
                    nav = {nav}
                    setFabricTypes = {setFabricTypes}
                    setSel = {setSel}
                    category = {category}
                    setImgState = {setImgState}
                    setNav = {setNav}
                    select  = {select }
                    types = {types}
                    sel ={sel}
                    Navs ={Navs}
                    Types = {Types}
                    process={process}
                    ID = {id}
                    />

                )}
              {(isMobile && !(nav!=null && nav === 0)) ? (
                        <div className="select-fabric-container mobile-view">
                            
                            <SelectFabric
                                category={category}
                                Fabric={Fabrics_all}
                                useFabric = {useFabric}
                                setUseFabric = {setUseFabric}
                                sel={sel}
                                setSel={setSel}
                                sHover={setHoverDets}
                                hoverState={setHover}
                                hover={sHover}
                                nav={nav}
                                setNav={setNav}
                                setFabricsAll={setFabricsAll}
                                setFabricTypes={setFabricTypes}
                                FabricTypes={FabricTypes}

                                menuOpen2={menuOpen2}
                                setMenuOpen2={setMenuOpen2}
                                menuOpen = {menuOpen}
                                clickHover={clickHover}
                                setClickHover={setClickHover}

                                getStyleImg = {getStyleImg}
                                setStylesAll = {setStylesAll}

                                imgState = {imgState}
                                setImgState = {setImgState}

                                fabSame={fabSame}
                                setFabSame={setFabSame}
                                fabricType = {fabricType}
                                setType = {setType}

                                process={process}
                                Navs = {Navs}
                            showFilter={showFilter}
                            setShowFilter={setShowFilter}
                            />
                            
                        </div>
                        
                    ) : !(nav!=null && nav === 0) ? (
                        <>
                        
                
                        
                        <SelectFabric
                            category={category}
                            Fabric={Fabrics_all}
                            useFabric = {useFabric}
                            setUseFabric = {setUseFabric}
                            sel={sel}
                            setSel={setSel}
                            sHover={setHoverDets}
                            hoverState={setHover}
                            hover={sHover}

                
                            nav={nav}
                            setNav={setNav}
                            setFabricsAll={setFabricsAll}
                            setFabricTypes={setFabricTypes}
                            FabricTypes={FabricTypes}

                            menuOpen2={menuOpen2}
                            setMenuOpen2={setMenuOpen2}
                            menuOpen = {menuOpen}

                            clickHover={clickHover}
                            setClickHover={setClickHover}

                            getStyleImg = {getStyleImg}
                            setStylesAll = {setStylesAll}

                            imgState = {imgState}
                            setImgState = {setImgState}

                            fabSame={fabSame}
                            setFabSame={setFabSame}

                            fabricType = {fabricType}
                            setType = {setType}

                            process={process}
                            Navs = {Navs}
                            showFilter={showFilter}
                            setShowFilter={setShowFilter}
                        />
                </>) : (<></>)}
                    
            </div>)  

            :nav == 1 ?  
            
                (<div className="fabricbody">
                    
                    
                    {/* Fabric page Filter */}
                    {showFilter && (
                        <FilterFabric 
                            Fabric={Fabrics_all}
                            useFabric = {useFabric}
                            setUseFabric = {setUseFabric}
                            useFilter = {useFilter}
                            currentFilters = {currentFilters}
                            setCurrentFilters = {setCurrentFilters}
                        />
                    )}

                    {/* Fabric hover details */}
                    {sHover == -1 && (
                        <div className="f-back-dark">
                        </div>
                    )
                    }
                    { (sHover == -1) && hoverDetils && (<div className="s-modal"
                    onClick={()=>{setMenuOpen2(false)}}
                        style={{"backgroundColor":"white"}}
                    >
                        {/* <div style={{"position":"relative", "width":"100%", "height":"100%", "backgroundColor":"white", "z-index":"1000"}}></div> */}
                        
                        {hoverDetils.link && hoverDetils.link.length > 0 && 
                           <a href={hoverDetils.link}>
                           <img style={{"position":"absolute", "left":"5px", "top":"5px", "zIndex":"1000", "width":"50px"}} src={youtube}/>
                           </a>
                        }
                        
                        <div style={{"position":"absolute", "backgroundColor":"white", "width":"25px", "left":"10px", "zIndex":"999"}} >  </div>
                        <div
                            onClick={()=>{
                                setHdes(true)
                                setHimg(0)
                                setHoverDets({})
                                setHover(-2)
                            }}
                        >
                        
                        <img 
                            type="button"
                        src={bclose} style={{right:"15px", "top":"15px", position:"absolute", "zIndex":"1", "width":"40px"}}/>
                        
                        </div>
                        
                        {LoadFabInfo && (<div className='f-loading'
                            style={{"position":"absolute"}}
                        >
                            <img alt src={aim} onError={(e) => { e.target.src='https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif'}}/>
                        </div>)}
                        { hoverDetils['single'] && hoverDetils['single'].length>0 ? 
                            (<>
                                {himg === 0 ? 
                                    (<img 
                                        onLoad={imageLoaded}
                                        src={hoverDetils['single'][0]} className="m-main-img"/>)
                                : himg === 1 ? 
                                (
                                    <img 
                                    onLoad={imageLoaded}
                                    src={hoverDetils['src']} className="m-main-img"/>
                                ) : 
                                (<img 
                                    onLoad={imageLoaded}
                                    src={hoverDetils['single'][himg-1]} className="m-main-img"/>)
                                }
                            </>) 
                            : 
                            (
                                <img 
                                onLoad={imageLoaded}
                                src={
                                    hoverDetils['src']}
                                className="m-main-img"/>
                            )
                        }

                        

                        <img  src={barrowL} className="m-f-img-l"
                            type="button"
                            onClick={()=>{

                                if(himg>0){
                                    // console.log("left click")
                                    setHimg(himg-1)
                                }
                            }}
                        />
                        <img src={barrowR}  className="m-f-img-r"
                            type="button"
                            onClick={()=>{
                                if(himg < hoverDetils['single'].length){
                                    // console.log("Right click")
                                    setHimg(himg+1)
                                }
                            }}
                        />
                        
                        <div className="s-hoverDes">
                            <img src={hDes ? `${dArrow}` : `${uArrow}`} className="m-f-arrow hori_center"
                                type="button"
                                onClick={()=>{setHdes(!hDes)}}
                            />
                            {(hDes) ? (<>
                            <div className="s-h-container">
                            <div className="s-h-des-1">
                                <label className="txt-font">{hoverDetils["name"]}</label>
                                <label className="txt-font1">by</label>
                                <img src={hoverDetils.brandImg} className="s-f-des-img hori_center" />
                                
                                <br/>

                                <label className="txt-small">{hoverDetils["des"]}</label>  
                                
                            </div>
                            <div className="s-h-line hori_center" ></div>
                            <div
                                style={{"width":"10%", "height":"100%"}}
                            ></div>
                            <div className="s-h-icons" style={isMobile ? {marginTop:"10%"} : {}}>
                                {fabricIcons.map((val1, key1)=>{
                                    return(<div style={ isMobile ? {"width":"90%","position":"relative"}:{"width":"90%", "position":"relative"}} className="hori_center">
                                        <label>{ ( (isMobile && key1 !=0) || (!isMobile) ) ? val1["des"] : '' }</label>
                                        <label style={ (isMobile && key1 ===0) ? {"position":"absolute", "left":"0"} : {"position":"absolute", "right":"0"}}>
                                        {hoverDetils[val1["attr"]]}
                                        {/* gr/Meter */}
                                        </label>
                                    </div>)
                                })}
                            </div>
                            </div>
                            </>): (
                            <div>
                                
                                <b>{hoverDetils["name"]} , {hoverDetils["brand"]} </b>
                            </div>) }
                        </div>
                    </div>)}

                    {/* {isMobile && (
            
            <div className="burger-menu" onClick={() => setMenuOpen2(!menuOpen2)}>
                        <span className="burger-menu-icon">Fabric</span>
                    </div> )
                    }  */}

            {/* {isMobile && (
                <div className="burger-menu2" onClick={() => setMenuOpen(!menuOpen)}>
                    <span className="burger-menu-icon2">Style</span>
                </div>
            )} */}

                {isMobile && (<div>


                    <StyleP
                        category = {category}
                        sel = {sel}
                        setSel = {setSel}
                        
                        setNav = {setNav}

                        // Styles = {StylesALL}
                        // setStylesAll = {setStylesAll}
                        getStyleImg = {getStyleImg}
                        setLoad = {setLoading}
                        menuOpen={menuOpen}
                        setMenuOpen={setMenuOpen}

                        imgState = {imgState}
                        setImgState=  {setImgState}

                        setIndication= {setIndication}
                        setJodh = {setJodh}

                        jodh={jodh}

                        process={process}
                        Navs = {Navs}
                        Buttons = {Buttons}
                        Tuxedo = {Tuxedo}
                        setOpenButtonSelection = {setOpenButtonSelection}
                        setSelectStyleItem = {setSelectStyleItem}
                    />

                    { (isEmbEnabled(category)) &&
                        <Embroidery 
                        sel={sel}
                        setSel={setSel}
                        embroidery = {embroidery}
                        embroideryStyle = {embroideryStyle}
                        getStyleImg = {getStyleImg}
                        menuOpenEmb = {menuOpenEmb}
                        setMenuOpenEmb={setMenuOpenEmb}
                        isMobile={isMobile}
                        embHoverDetails={embHoverDetails}
                        setEmbHoverDetails={setEmbHoverDetails}
                        imgState={imgState}
                        setImgState={setImgState}
                        setLoading={setLoading}
                    />
                    }
                    

                   </div>                    
                    )}
                    
                    

                    <SelectFabric
                        category={category}
                        Fabric = {Fabrics_all}
                        useFabric = {useFabric}
                        setUseFabric = {setUseFabric}

                        sel = {sel}
                        setSel = {setSel}
                        
                        sHover = {setHoverDets}
                        hoverState = {setHover}
                        hover = {sHover}

                        nav = {nav}
                        setNav={setNav}

                        setFabricsAll = {setFabricsAll}
                        setFabricTypes= {setFabricTypes}
                        FabricTypes = {FabricTypes}

                        menuOpen2={menuOpen2}
                        setMenuOpen2={setMenuOpen2}
                        menuOpen = {menuOpen}

                        clickHover={clickHover}
                        setClickHover={setClickHover}

                        getStyleImg = {getStyleImg}
                        setStylesAll = {setStylesAll}

                        imgState = {imgState}
                        setImgState = {setImgState}

                        fabSame={fabSame}
                        setFabSame={setFabSame}
                        
                        fabricType = {fabricType}
                        setType = {setType}

                        process={process}
                        Navs = {Navs}
                        showFilter={showFilter}
                        setShowFilter={setShowFilter}
                    />
                    

                    
                    <ViewFabric
                        category = {category}
                        sel = {sel}
                        setSel = {setSel}
                        nav = {nav}
                        setNav = {setNav}

                        loading ={loading}
                        setLoading={setLoading}

                        single = {single}
                        state={state}
                        setStates={setStates}

                        setStylesAll = {setStylesAll}
                        
                        setMenuOpen = {setMenuOpen}
                        menuOpen = {menuOpen}

                        setMenuOpen2 = {setMenuOpen2}
                        menuOpen2 = {menuOpen2}

                        imgState = {imgState}
                        setImgState = {setImgState}

                        fabricType = {fabricType}
                        setType = {setType}

                        jodh = {jodh}

                        mess = {mess}
                        setMess = {setMess}

                        process={process}
                        Navs = {Navs}

                        menuOpenEmb = {menuOpenEmb}
                        setMenuOpenEmb={setMenuOpenEmb}

                        setCurrBody={setCurrBody}
                        currBody={currBody}

                        getStyleImg = {getStyleImg}
                    />

                    
                    
                </div>)
            : nav == 2 ?
            
                (<div className="StyleBody">
            

                    {isMobile && (<div>
                        <SelectFabric
                        category={category}
                        Fabric = {Fabrics_all}
                        useFabric = {useFabric}
                        setUseFabric = {setUseFabric}

                        sel = {sel}
                        setSel = {setSel}
                        
                        sHover = {setHoverDets}
                        hoverState = {setHover}
                        hover = {sHover}
                        
                        nav = {nav}
                        setNav={setNav}

                        setFabricsAll = {setFabricsAll}
                        setFabricTypes= {setFabricTypes}
                        FabricTypes = {FabricTypes}

                        menuOpen2={menuOpen2}
                        setMenuOpen2={setMenuOpen2}
                        menuOpen = {menuOpen}
                        
                        clickHover={clickHover}
                        setClickHover={setClickHover}

                        getStyleImg = {getStyleImg}
                        setStylesAll = {setStylesAll}
                        
                        imgState = {imgState}
                        setImgState = {setImgState}

                        fabSame={fabSame}
                        setFabSame={setFabSame}
                    
                        fabricType = {fabricType}
                        setType = {setType}

                        process={process}
                        Navs = {Navs}
                        showFilter={showFilter}
                        setShowFilter={setShowFilter}
                    />
                    { (isEmbEnabled(category)) &&
                    <Embroidery 
                        sel={sel}
                        setSel={setSel}
                        embroidery = {embroidery}
                        embroideryStyle = {embroideryStyle}
                        getStyleImg = {getStyleImg}
                        menuOpenEmb = {menuOpenEmb}
                        setMenuOpenEmb={setMenuOpenEmb}
                        isMobile={isMobile}
                        embHoverDetails={embHoverDetails}
                        setEmbHoverDetails={setEmbHoverDetails}
                        imgState={imgState}
                        setImgState={setImgState}
                        setLoading={setLoading}
                    />}
                    </div>
                    )}
                    
                    <StyleP
                        category = {category}
                        sel = {sel}
                        setSel = {setSel}
                        
                        setNav = {setNav}

                        // Styles = {StylesALL}
                        // setStylesAll = {setStylesAll}
                        getStyleImg = {getStyleImg}
                        setLoad = {setLoading}
                        menuOpen={menuOpen}
                        setMenuOpen={setMenuOpen}

                        imgState = {imgState}
                        setImgState=  {setImgState}

                        setIndication= {setIndication}

                        setJodh = {setJodh}

                        jodh={jodh}

                        process={process}
                        Navs = {Navs}
                        Buttons = {Buttons}
                        Tuxedo = {Tuxedo}
                        setOpenButtonSelection = {setOpenButtonSelection}
                        setSelectStyleItem = {setSelectStyleItem}
                    />

                    <ViewFabric
                        category = {category}
                        sel = {sel}
                        nav = {nav}
                        setSel = {setSel}
                        setNav = {setNav}

                        loading ={loading}
                        setLoading={setLoading}

                        single = {single}
                        state={state}
                        
                        setStylesAll = {setStylesAll}

                        setMenuOpen = {setMenuOpen}
                        menuOpen = {menuOpen}

                        setMenuOpen2 = {setMenuOpen2}
                        menuOpen2 = {menuOpen2}

                        imgState = {imgState}
                        setImgState = {setImgState}

                        fabricType = {fabricType}
                        setType = {setType}

                        jodh = {jodh}

                        mess = {mess}
                        setMess = {setMess}

                        process={process}
                        Navs = {Navs}

                        menuOpenEmb = {menuOpenEmb}
                        setMenuOpenEmb={setMenuOpenEmb}

                        setCurrBody={setCurrBody}
                        currBody={currBody}

                        getStyleImg = {getStyleImg}
                    />
                </div>)
            : (nav === 3 && isEmbEnabled(category)) ?
            <div className="embroideryBody">

                <Embroidery 
                    sel={sel}
                    setSel={setSel}
                    embroidery = {embroidery}
                    embroideryStyle = {embroideryStyle}
                    getStyleImg = {getStyleImg}
                    menuOpenEmb = {menuOpenEmb}
                    setMenuOpenEmb={setMenuOpenEmb}
                    isMobile={isMobile}
                    embHoverDetails={embHoverDetails}
                    setEmbHoverDetails={setEmbHoverDetails}
                    imgState={imgState}
                    setImgState={setImgState}
                    setLoading={setLoading}
                />

                <ViewFabric
                        category = {category}
                        sel = {sel}
                        setSel = {setSel}
                        nav = {nav}
                        setNav = {setNav}

                        loading ={loading}
                        setLoading={setLoading}

                        single = {single}
                        state={state}
                        setStates={setStates}

                        setStylesAll = {setStylesAll}
                        
                        setMenuOpen = {setMenuOpen}
                        menuOpen = {menuOpen}

                        setMenuOpen2 = {setMenuOpen2}
                        menuOpen2 = {menuOpen2}

                        imgState = {imgState}
                        setImgState = {setImgState}

                        fabricType = {fabricType}
                        setType = {setType}

                        jodh = {jodh}

                        mess = {mess}
                        setMess = {setMess}

                        process={process}
                        Navs = {Navs}

                        menuOpenEmb = {menuOpenEmb}
                        setMenuOpenEmb={setMenuOpenEmb}

                        setCurrBody={setCurrBody}
                        currBody={currBody}

                        getStyleImg = {getStyleImg}
                    />
            </div>
                

            : (nav === 3 && category !== "suit") ?
                (<>
                    <NavBar
                        flag={1}
                    />
                    <Measurement
                        nav = {nav}
                        setNav = {setNav}
                        section = {section}
                        setSection = {setSection}
                        type={1}
                    />
                </>
                
                )
            : (nav === 4 && isEmbEnabled(category)) ?
                (<>
                    <NavBar
                        flag={1}
                    />
                    <Measurement
                        nav = {nav}
                        setNav = {setNav}
                        section = {section}
                        setSection = {setSection}
                        type={1}
                    />
                </>
                )
            : (<> Nothing Found</>)

            }

                
        </div>
    )

}
